<script>
import store from '../store/index.js';
import spec from './spec/index.vue';
import rpTips from './rpTips';
import price from './price';
import city from './city';
import dealer from './dealer';
import labelInput from './labelInput';
import formSubmit from './submit';
import statement from "./statement";
import success from './success';
// const success = () => import('./success');
export default {
    data() {
        return {
            load: !window.__PRERENDER_INJECTED,
            mobileConf: {
                id: 'mobile',
                label: '手机号',
                maxLength: 11,
                placeholder: '请输入手机号',
                errMsg: '请输入正确格式的手机号',
                verify: {
                    change(val) {
                        return /^1\d{10}$/.test(val);
                    },
                    input(val) {
                        return /^\d{1,11}$/.test(val);
                    }
                }
            },
            nameConf: {
                id: 'name',
                label: '姓名',
                maxLength: 10,
                placeholder: '如王先生、李女士',
                errMsg: '请输入您的姓名',
                verify: {
                    change(val) {
                        return val.trim() !== '';
                    }
                }
            }
        }
    },
    computed: {
        mobile: {
            get() {
                return store.form.mobile;
            },
            set(val) {
                store.form.mobile = val;
            }
        },
        name: {
            get() {
                return store.form.name;
            },
            set(val) {
                store.form.name = val;
            }
        }
    },
    // watch: {
    //     'store.form.dealers': function() {
    //         alert(123);
    //         this.$refs.dealer.checkChange();
    //     }
    // },
    methods: {
        check() {
            const mobileError = this.$refs.mobile.checkChange();
            const nameError = this.$refs.name.checkChange();
            // const dealerError = this.$refs.dealer.checkChange();
            return mobileError || nameError;
        },
        async submit() {
            const isError = this.check();
            if (isError) {
                return;
            }
            
            const result = await store.submit();
            if (!result.status) {
                this.$Alert({
                    title: '提示',
                    content: result.msg
                }).show();
                return;
            }
            this.$refs.success.show();
        }
    },
    components: {
        spec,
        rpTips,
        price,
        city,
        labelInput,
        dealer,
        formSubmit,
        statement,
        success
    }
}
</script>

<template>
    <div id="form" class="form-wrap">
        <div class="form-top-symbol">
            <div class="symbol-back"></div>
            <div class="symbol-front">
                <img src="../../assets/form-top.png" alt="">
            </div>
        </div>
        <div class="form-inner">
            <spec></spec>
            <rp-tips></rp-tips>
            <price></price>
            <city></city>
            <label-input ref="name" :params="nameConf" v-model="name"></label-input>
            <label-input ref="mobile" :params="mobileConf" v-model="mobile"></label-input>
            <!-- <dealer ref="dealer"></dealer> -->
            <form-submit @click="submit"></form-submit>
            <statement></statement>
            <success ref="success" v-if="load"></success>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.form-wrap
    position relative
    margin 1.44rem 0.8rem 0
    padding 0.32rem
    border-radius 0.213rem
    background-color #e7d1ff
.form-top-symbol
    position absolute
    top -12px
    left 0
    right 0
    margin auto
    width 16.26rem
    text-align center
    font-size 0
    .symbol-back
        position absolute
        top 6px
        width 100%
        height 12px
        border-radius 6px
        background-color rgba(231, 209, 255, .53)
    .symbol-front
        display inline-block
.form-inner
    padding 0 1.173rem
    border-radius 0.213rem
    background-color #ffF
    overflow hidden
</style>
